import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { trackWhatsAppClick } from "@/lib/gtag";
import { buildWhatsAppUrl } from "@/lib/whatsapp";

const WhatsAppButton = () => {
  const { t } = useTranslation();
  return (
    <a
      href={buildWhatsAppUrl(t("whatsapp.defaultMessage"))}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWhatsAppClick('floating_button')}
      className="fixed bottom-4 right-4 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-[#25D366] text-white shadow-md hover:bg-[#1ebe5a] hover:shadow-lg transition-all"
      aria-label={t("whatsapp.floatingAria")}
    >
      <MessageCircle className="h-5 w-5" />
    </a>
  );
};

export default WhatsAppButton;
